import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// import { useLastLocation } from 'react-router-last-location'; UPDATING TODO: VERIFICAR SUBSTITUTO
import { Button, Icon, Center, Text } from '@chakra-ui/react';
import { IoAlertCircleOutline } from 'react-icons/io5';

import { getApiError } from 'src/api/utils';

import { useEventQuery } from './queries';
import { useReferral } from './hooks';
import { SEOEvent } from './_components';
import EventProvider from './provider';
import { useCartStore } from './stores';

import './styles.scss';
import { EventRoutes } from './Routes';

const Event = () => {
  const navigation = useNavigate();
  const { eventID } = useParams();
  const referral = useReferral(eventID!);

  const urlParams = new URLSearchParams(window.location.search);
  const privateLinkName = urlParams.get('linkname');

  const eventQuery = useEventQuery(privateLinkName ? `${eventID}?linkname=${privateLinkName}` : eventID!, referral);
  const { getEventCart, reinitializeEventCart } = useCartStore();

  const handleOnClickSeeEvents = () => {
    navigation('/', { replace: true });
  };

  React.useEffect(() => {
    if (!eventQuery.isLoading && getEventCart(eventID!).length === 0) {
      reinitializeEventCart(eventID!, eventQuery.data?.ticketTypes);
    }
  }, [
    eventID,
    eventQuery.data?.ticketTypes,
    eventQuery.isLoading,
    getEventCart,
    reinitializeEventCart,
  ]);

  if (eventQuery.isLoading) {
    return null;
  }

  if (eventQuery.isError) {
    return (
      <Center color="gray.300" flexDirection="column" h="calc(100vh - 100px)">
        <Icon as={IoAlertCircleOutline} boxSize={20} />
        <Text fontSize="lg" maxW="md" textAlign="center" m={4}>
          {getApiError(eventQuery.error).message}
        </Text>
        <Button
          colorScheme="gray"
          rounded="full"
          onClick={handleOnClickSeeEvents}>
          Ver eventos
        </Button>
      </Center>
    );
  }

  return (
    <EventProvider id={eventID!}>
      <SEOEvent event={eventQuery.data} />
      <EventRoutes />
    </EventProvider>
  );
};

export default Event;
